import { Swiper } from "swiper/react";

const ArtistSkeleton = () => {
  const arr = [1, 2, 3, 4, 5, 6];
  return (
    <div>
      <div className="">
        <Swiper
          slidesPerView={6}
          breakpoints={{
            0: {
              slidesPerView: 1,
            },
            350: {
              slidesPerView: 2,
            },
            500: {
              slidesPerView: 3,
            },
            1100: {
              slidesPerView: 4,
            },
            1300: {
              slidesPerView: 5,
            },
            1500: {
              slidesPerView: 6,
            },
          }}
          className="mt-5 mb-5 mySwiper"
        >
          <div className="flex flex-row lg:gap-[20px] sm:gap-[20px]">
            {arr.map((item: any) => (
              <div
                key={item}
                className="flex flex-col items-center justify-center animate-pulse"
              >
                <div className="w-[120px] h-[120px] rounded-full bg-[#1a1919]"></div>
                <div className="w-[100px] h-[20px] mt-3 bg-[#1a1919]"></div>
              </div>
            ))}
          </div>
        </Swiper>
      </div>
    </div>
  );
};

export default ArtistSkeleton;
